// Duplicate of https://git.hubteam.com/HubSpot/customer-data-objects-ui-components/blob/master/static/js/ErrorBoundary.js
import * as React from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import I18n from 'I18n';
import once from 'transmute/once';
import { Link } from 'foundations-components/transitional/components/Link';
import { trackErrorBoundaryTriggered } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
let addRefreshAlert;
function _addRefreshAlert(id) {
  FloatingAlertStore.addAlert({
    id,
    type: 'danger',
    use: 'inline',
    titleText: I18n.text('componentErrorAlert.title'),
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "componentErrorAlert.message_jsx",
      options: {
        href: window.location.href
      },
      elements: {
        Link
      }
    }),
    // if they close the alert, reset the timer in case something else breaks
    onClose: () => {
      addRefreshAlert = once(_addRefreshAlert);
    }
  });
}

// if a bunch of things break at the same time, during a critsit or something,
// we don't want to show the alert a million times. show it once, and reset if
// they clear it (see onClose above)
addRefreshAlert = once(_addRefreshAlert);
/**
 * Usage:
 *   <ErrorBoundary boundaryName="MyComponent_MyError" ErrorComponent={MyError} errorProps={{ foo: 'bar' }}>
 *     <MyComponent />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.attemptToRemount = () => {
      const {
        boundaryName,
        showRefreshAlert
      } = this.props;
      if (showRefreshAlert && boundaryName) {
        addRefreshAlert = once(_addRefreshAlert);
        FloatingAlertStore.removeAlert(boundaryName);
      }
      this.setState({
        hasError: false
      });
    };
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info = {}) {
    this.reportErrors(error, info);
  }

  // Passed to the ErrorComponent to allow for a manual reset of the component.

  reportErrors(error, info = {}) {
    const boundaryName = this.props.boundaryName || '';
    trackErrorBoundaryTriggered({
      error,
      info,
      boundaryName
    });
    if (this.props.showRefreshAlert) {
      addRefreshAlert(boundaryName);
    }
  }
  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    const {
      ErrorComponent
    } = this.props;
    if (this.state.hasError && ErrorComponent) {
      return /*#__PURE__*/_jsx(ErrorComponent, Object.assign({}, this.props.errorProps, {
        attemptToRemount: this.attemptToRemount
      }));
    }
    return null;
  }
}
ErrorBoundary.defaultProps = {
  showRefreshAlert: true
};
export default ErrorBoundary;